<template>
  <div>
    <FormLoading v-if="bankDataLoading" />

    <BankCard :row="bankData" :balanceLoading="bankBalanceLoading" v-else />
    <router-view :bankId="bankData.id" @refreshBankBalance="refreshBankBalance" @loadingBankBalance="loadingBankBalance" @getBankData="getBankData"></router-view>
  </div>
</template>
<script>
import BankCard from "@/components/bank/BankCard.vue";

export default {
  components: {
    BankCard,
  },
  data() {
    return {
      bankData: {},
      bankBalance: 0,
      bankBalanceLoading: false,
      bankDataLoading: true,
    };
  },
  methods: {
    refreshBankBalance(newBalance) {
      this.bankBalance = newBalance;
      this.bankBalanceLoading = false;
    },
    loadingBankBalance() {
      this.bankBalanceLoading = true;
    },
    getBankData() {
      this.loadingBankBalance();
      const bankId = this.$route.params.bankId;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/bank-account?uuid=" + bankId)
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.bankData = data;
            this.bankDataLoading = false;
            this.refreshBankBalance(this.bankData.balance)
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            // console.log("er");
          }
        })
        .finally(() => {});
    },
  },
};
</script>
